import { styleConstants } from '@paywithextend/components'
import React from 'react'
import AppName from 'src/components/AppName/AppName'
import Tooltip from 'src/components/Tooltip/Tooltip'
import Trns from 'src/localization/Trns'
import { css } from 'styled-components'

interface OriginTooltipProps {
  openLeft: boolean
}

const OriginTooltip: React.FC<OriginTooltipProps> = (
  props,
): React.ReactElement => {
  return (
    <Tooltip
      openLeft={props.openLeft}
      css={css`
        max-height: 18px;
      `}
    >
      <p>
        <Trns
          source={
            '${virtual} indicates this transaction was made on a Virtual Card.'
          }
          expressions={{
            virtual: (
              <span
                css={css`
                  font-family: ${styleConstants.fontFamilies.medium};
                `}
              >
                <Trns source={'Virtual'} />
              </span>
            ),
          }}
        />
      </p>
      <p
        css={css`
          margin-top: 12px;
        `}
      >
        <Trns
          source={
            '${physical} or ${other} indicates this transaction was made with a physical card, and imported into ${appName}.'
          }
          expressions={{
            physical: (
              <span
                css={css`
                  font-family: ${styleConstants.fontFamilies.medium};
                `}
              >
                <Trns source={'Physical'} />
              </span>
            ),
            other: (
              <span
                css={css`
                  font-family: ${styleConstants.fontFamilies.medium};
                `}
              >
                <Trns source={'Other'} />
              </span>
            ),
            appName: <AppName />,
          }}
        />
      </p>
    </Tooltip>
  )
}

export default OriginTooltip
